
// Generated by dayjs-nuxt-module
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'

import 'dayjs/locale/da'
import duration from 'dayjs/plugin/duration'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localeData from 'dayjs/plugin/localeData'
import isBetween from 'dayjs/plugin/isBetween'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'


dayjs.extend(updateLocale)

dayjs.extend(duration)
dayjs.extend(customParseFormat)
dayjs.extend(localeData)
dayjs.extend(isBetween)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(utc)



// defaultLocale: ["da",{"name":"da","weekdays":["søndag","mandag","tirsdag","onsdag","torsdag","fredag","lørdag"],"weekdaysShort":["søn.","man.","tirs.","ons.","tors.","fre.","lør."],"weekdaysMin":["sø.","ma.","ti.","on.","to.","fr.","lø."],"months":["januar","februar","marts","april","maj","juni","juli","august","september","oktober","november","december"],"monthsShort":["jan.","feb.","mar.","apr.","maj","juni","juli","aug.","sept.","okt.","nov.","dec."],"weekStart":1,"yearStart":4,"formats":{"LT":"HH:mm","LTS":"HH:mm:ss","L":"DD.MM.YYYY","LL":"D. MMMM YYYY","LLL":"D. MMMM YYYY HH:mm","LLLL":"dddd [d.] D. MMMM YYYY [kl.] HH:mm"},"relativeTime":{"future":"om %s","past":"%s siden","s":"få sekunder","m":"et minut","mm":"%d minutter","h":"en time","hh":"%d timer","d":"en dag","dd":"%d dage","M":"en måned","MM":"%d måneder","y":"et år","yy":"%d år"}}]


dayjs.updateLocale("da",{"name":"da","weekdays":["søndag","mandag","tirsdag","onsdag","torsdag","fredag","lørdag"],"weekdaysShort":["søn.","man.","tirs.","ons.","tors.","fre.","lør."],"weekdaysMin":["sø.","ma.","ti.","on.","to.","fr.","lø."],"months":["januar","februar","marts","april","maj","juni","juli","august","september","oktober","november","december"],"monthsShort":["jan.","feb.","mar.","apr.","maj","juni","juli","aug.","sept.","okt.","nov.","dec."],"weekStart":1,"yearStart":4,"formats":{"LT":"HH:mm","LTS":"HH:mm:ss","L":"DD.MM.YYYY","LL":"D. MMMM YYYY","LLL":"D. MMMM YYYY HH:mm","LLLL":"dddd [d.] D. MMMM YYYY [kl.] HH:mm"},"relativeTime":{"future":"om %s","past":"%s siden","s":"få sekunder","m":"et minut","mm":"%d minutter","h":"en time","hh":"%d timer","d":"en dag","dd":"%d dage","M":"en måned","MM":"%d måneder","y":"et år","yy":"%d år"}})
dayjs.locale('da')


export default dayjs
